import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3edb71c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Project Preferences"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-6" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check out "),
    /*#__PURE__*/_createElementVNode("a", { class: "link-primary fw-bolder" }, "Help Page"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1))
const _hoisted_3 = { class: "mb-10 fv-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label mb-3" }, "What status should potential projects have?", -1))
const _hoisted_5 = { class: "mb-0 fv-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label mb-3" }, "What are your preferred industry verticals?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Field, { name: "projectStatuses" }, {
        default: _withCtx(({ field }) => [
          _createVNode(_component_Multiselect, _mergeProps({
            valueProp: "id",
            class: "multiselect-blue"
          }, field, {
            options: _ctx.projectStatuses,
            mode: "tags",
            searchable: true,
            label: "name",
            trackBy: "name"
          }), null, 16, ["options"])
        ]),
        _: 1
      }),
      _createVNode(_component_ErrorMessage, {
        name: "projectStatuses",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_Field, {
        class: "form-control form-control-lg form-control-solid",
        name: "industryVerticals"
      }, {
        default: _withCtx(({ field }) => [
          _createVNode(_component_Multiselect, _mergeProps({
            valueProp: "id",
            class: "multiselect-blue"
          }, field, {
            options: _ctx.allIndustries,
            mode: "tags",
            searchable: true,
            label: "name",
            trackBy: "name"
          }), null, 16, ["options"])
        ]),
        _: 1
      }),
      _createVNode(_component_ErrorMessage, {
        name: "industryVerticals",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ])
  ]))
}